import {
  Box,
  Image,
  ImageProps,
  Popover,
  PopoverArrow,
  PopoverContent,
  PopoverContentProps,
  PopoverTrigger,
  useDisclosure,
} from "@chakra-ui/react";
import React from "react";

interface Props {
  imageProps?: ImageProps;
  size?: PopoverContentProps["w"];
}
export function InfoPopover({
  children,
  imageProps = {},
  size = "3xs",
}: React.PropsWithChildren<Props>) {
  const { isOpen, onToggle, onClose } = useDisclosure();

  return (
    <Popover
      closeOnBlur
      isOpen={isOpen}
      onClose={onClose}
      placement="right"
      variant="info"
    >
      <PopoverTrigger>
        <Image
          cursor="pointer"
          display="inline-block"
          filter="var(--filter-royalblue-100)"
          h={4}
          onClick={onToggle}
          src="/svg/info.svg"
          placeSelf="end"
          w={4}
          {...imageProps}
        />
      </PopoverTrigger>
      <PopoverContent
        _focusVisible={{ outline: "none" }}
        bg="brand.black.90"
        border="none"
        borderRadius={8}
        color="brand.white.100"
        fontSize="sm"
        p={2}
        w={size}
      >
        <PopoverArrow bg="brand.black.90" />
        <Box>{children}</Box>
      </PopoverContent>
    </Popover>
  );
}
